import { useState, useCallback } from "react";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip, Badge, IconButton } from "@material-ui/core";
import { columnTextField } from "utils/tables-utils";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaskAndValid from "utils/maskAndValid";

const STATUS_COLORS = {
  CONFIRMADO: "#2dce89",
  ABERTO: "#f80031",
  PENDENTE: "#ffd600",
  FINALIZADO: "#233dd2",
};

const useCustomStyles = makeStyles((theme) => ({
  badge: ({ status }) => ({
    backgroundColor: STATUS_COLORS[status],
    height: 20,
    width: 20,
    borderRadius: 10,
    border: "none",
  }),
  root: {
    margin: "0 0.5rem",
  },
}));

const ColoredStatus = ({ status }) => {
  const classes = useCustomStyles({ status });

  return (
    <Tooltip title={status}>
      <Badge
        overlap="circle"
        badgeContent=" "
        color="primary"
        classes={{ badge: classes.badge, root: classes.root }}
      />
    </Tooltip>
  );
};

export default function TableVitrinesEnviadas({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  search,
  setOpenDialogDetail,
}) {
  const [loading, setLoading] = useState(false);

  const columnModel = [
    {
      dataField: "StatusVitrineConsumidor",
      text: "Status da Vitrine",
      align: "center",
      isDummyField: true,
      csvExport: false,
      headerAlign: "center",
      formatter: (_, row) => (
        <ColoredStatus status={row?.StatusVitrineConsumidor} />
      ),
    },
    columnTextField({
      dataField: "NomeConsumidor",
      text: "Cliente",
      align: "center",
    }),
    columnTextField({
      dataField: "CpfConsumidor",
      text: "CPF",
      align: "center",
      formatter: MaskAndValid.maskCPNJCPF,
    }),
    columnTextField({
      dataField: "Telefone",
      text: "Telefone",
      align: "center",
      formatter: (params) => (params ? MaskAndValid.maskPhone(params) : ""),
    }),
    columnTextField({
      dataField: "Nome",
      text: "Vitrine",
      align: "center",
    }),
    columnTextField({
      dataField: "DataInclusaoVitrineConsumidorFormat",
      text: "Data criação do link",
      align: "center",
    }),
    columnTextField({
      dataField: "VitrinePublica",
      text: "Tipo",
      align: "center",
      formatter: (params) => (params ? "Compartilhada" : "Exclusiva"),
    }),
    columnTextField({
      dataField: "Vendedor",
      text: "Vendedor",
      align: "center",
    }),
    columnTextField({
      dataField: "Loja",
      text: "Loja",
      align: "center",
    }),
    {
      dataField: "visualizar",
      text: "",
      isDummyField: true,
      headerStyle: { width: 30 },
      formatter: (_, row) => (
        <Tooltip title="Detalhes da Vitrine">
          <IconButton
            aria-label="visualizar"
            onClick={() => setOpenDialogDetail(row)}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const doSearch = useCallback(
    async (page, sizePerPage) => {
      setLoading(true);
      try {
        await search({ page, sizePerPage });
      } finally {
        setLoading(false);
      }
    },
    [search]
  );

  const handlePageChange = useCallback(
    (page, sizePerPage) => doSearch(page, sizePerPage),
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => doSearch(page, sizePerPage),
    [doSearch]
  );

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="IdVitrineVirtualConsumidor"
      dataTable={dataTable}
      columnModel={columnModel}
      headerTitle="Vitrines Enviadas"
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        totalSize: totalRegistros,
        showTotal: true,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      loading={loading}
      notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
      bootstrapTableProps={{
        remote: true,
      }}
    />
  );
}
